module.exports = __webpack_public_path__ + "img/EditIcon.7ab468b6.svg";